import * as DSAssetFamilies from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { Map as ImmutableMap } from 'immutable';
import { parseDynamicFilterFamilyId } from 'customer-data-filters-ui/filterQueryFormat/DynamicFilterFamilies';
import unescapedText from 'I18n/utils/unescapedText';
export const getIntegrationName = (integrationId, integrations) => {
  const integration = integrations ? integrations.get(parseDynamicFilterFamilyId(DSAssetFamilies.INTEGRATION, integrationId)) : undefined;
  return integration ? integration.get('label') : unescapedText(`customerDataFiltersUI.customerDataFilters.DSAssetFamilyNames.${DSAssetFamilies.INTEGRATION.toUpperCase()}`);
};
export const getUnifiedEventCategoryGroupName = (filterFamily, unifiedEvents = ImmutableMap()) => {
  const categoryGroupName = parseDynamicFilterFamilyId(DSAssetFamilies.UNIFIED_EVENT, filterFamily);
  const event = unifiedEvents.find(ue => ue.categoryGroupName === categoryGroupName);
  if (event && event.categoryGroupLabel) {
    return event.categoryGroupLabel;
  }
  return categoryGroupName;
};
export const getUnifiedEventName = (filterFamily, unifiedEvents = ImmutableMap()) => {
  const event = unifiedEvents.get(filterFamily);
  if (event && event.label) {
    return event.label;
  }
  return filterFamily;
};
export const getCustomBehavioralEventName = (filterFamily, customBehavioralEvents = ImmutableMap()) => {
  const event = customBehavioralEvents.get(filterFamily);
  if (event && event.label) {
    return event.label;
  }
  return filterFamily;
};
export const getIntegratorEventName = (filterFamily, events = ImmutableMap()) => {
  const event = events.get(filterFamily);
  if (event && event.label) {
    return event.label;
  }
  return filterFamily;
};
export const getObjectName = ({
  objectTypeId,
  isPlural = false,
  objectDefinitions
}) => {
  if (!objectDefinitions) {
    return objectTypeId;
  }
  const objectDefinition = objectDefinitions.get(objectTypeId) || ImmutableMap();
  const objectNameForm = isPlural ? 'pluralForm' : 'singularForm';
  return objectDefinition.get(objectNameForm) || objectDefinition.get('name');
};